import { ArrowRight, Copy } from "lucide-react";
import { useRef } from "react";
import toast from "react-hot-toast";
import { SITE } from "../../data/site";
import { gsap, MOTION_OK, useGSAP } from "../../lib/gsap";
import { DeliveryRider } from "../illustrations/DeliveryRider";
import { COUPON_STORAGE_KEY } from "../cart/CouponField";
import { Button } from "../ui/Button";

export const BannerPromo = () => {
  const ref = useRef<HTMLDivElement>(null);
  const { promo } = SITE;

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        gsap.from("[data-rider]", {
          xPercent: 70,
          autoAlpha: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: { trigger: ref.current, start: "top 75%", once: true },
        });
        // "Trepidação" da moto.
        gsap.to("[data-rider-bob]", { y: -5, duration: 0.45, ease: "sine.inOut", yoyo: true, repeat: -1 });
      });
    },
    { scope: ref },
  );

  const copyCoupon = async () => {
    try {
      sessionStorage.setItem(COUPON_STORAGE_KEY, promo.code);
    } catch {
      // Sem sessionStorage o cliente digita o cupom no checkout.
    }
    try {
      await navigator.clipboard.writeText(promo.code);
      toast.success("Cupom copiado! Ele já vai preenchido no checkout.");
    } catch {
      toast.error("Não foi possível copiar o cupom.");
    }
  };

  return (
    <section aria-labelledby="promo-title" className="bg-night px-4 pb-24 sm:px-6 lg:px-8">
      <div
        ref={ref}
        className="relative isolate mx-auto grid max-w-7xl items-center gap-6 overflow-hidden rounded-[2rem] bg-primary px-6 py-12 text-night sm:px-12 lg:grid-cols-[1.15fr_1fr] lg:py-16"
      >
        <div aria-hidden="true" className="absolute inset-0 -z-10">
          <div className="absolute inset-0 opacity-[0.12] [background-image:radial-gradient(#0A0A0A_1.2px,transparent_1.2px)] [background-size:18px_18px]" />
          <div className="absolute -bottom-24 -right-16 size-80 rounded-full bg-white/25 blur-3xl" />
          <span className="absolute -bottom-12 right-6 select-none font-display text-[11rem] leading-none text-night/[0.05] sm:text-[16rem]">
            NINJA
          </span>
        </div>

        <div className="text-center lg:text-left">
          <p className="-rotate-2 font-script text-3xl sm:text-4xl">Com fome?</p>
          <h2 id="promo-title" className="font-display text-6xl leading-[0.9] tracking-wide sm:text-7xl lg:text-8xl">
            Entregamos rápido
          </h2>

          {promo.enabled && (
            <>
              <p className="mt-5 text-lg font-semibold">
                <span className="rounded-md bg-night px-2 py-0.5 text-primary">{promo.discount}</span> {promo.description}
              </p>
              <div className="mt-6 inline-flex items-center gap-4 rounded-2xl border-2 border-dashed border-night/40 bg-white/35 py-2 pl-5 pr-2">
                <span className="text-left">
                  <span className="block text-[10px] font-semibold uppercase tracking-[0.25em] text-night/70">Cupom</span>
                  <span className="block font-display text-3xl leading-none tracking-[0.15em]">{promo.code}</span>
                </span>
                <button
                  type="button"
                  onClick={copyCoupon}
                  className="inline-flex items-center gap-2 rounded-xl bg-night px-4 py-2.5 text-sm font-semibold text-white transition-transform hover:scale-[1.03] focus-visible:outline-night"
                >
                  <Copy className="size-4" aria-hidden="true" /> Copiar
                </button>
              </div>
            </>
          )}

          <div className="mt-8">
            <Button to="/cardapio" variant="dark" size="lg" icon={<ArrowRight className="size-5" aria-hidden="true" />}>
              Pedir agora
            </Button>
          </div>
        </div>

        <div data-rider className="mx-auto w-full max-w-md lg:max-w-none">
          <div data-rider-bob>
            <DeliveryRider className="w-full" />
          </div>
        </div>
      </div>
    </section>
  );
};
